import { of, pipe } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import {
  ScriptData,
  ScriptErrorResponse,
  ScriptExecutionResponse,
} from '../code';
import { ScriptWorkerService } from '../services';
import { State } from '../services/work.state';
import { EnvironmentVariables } from '@adreno-common';

export const executeExit = (
  scriptWorker: ScriptWorkerService,
  environment: EnvironmentVariables
) =>
  pipe(
    switchMap(([state, currentState]: [Partial<State>, State]) => {
      if (
        state.system?.navToQ === '?' &&
        !!state.system?.qHistory &&
        state.system?.qHistory.length > 0
      ) {
        const { system, master, action, answers, variables, inputs } = {
          ...currentState,
          ...state,
        };
        return scriptWorker
          .send$({
            type: 'exit',
            question: state.system!.qHistory![0],
            app: {
              system: {
                ...state.system,
                navToQ: undefined,
              },
              master,
              action,
              answers,
              variables,
              inputs,
              apiPath: environment.apiPath,
            } as ScriptData,
          })
          .pipe(
            map((res) => res as ScriptExecutionResponse | ScriptErrorResponse),
            map((execResp) => {
              if (execResp.type === 'error') {
                return {
                  ...state,
                  qNo: execResp.question,
                  ...execResp.data,
                  system: {
                    ...state.system,
                    error: execResp.error.message,
                    navToQ: undefined,
                  },
                };
              }
              return {
                ...state,
                ...execResp.app,
              };
            }),
            map((state) => [state, currentState] as [Partial<State>, State])
          );
      } else {
        return of([state, currentState] as [Partial<State>, State]);
      }
    })
  );
